import React from 'react'
import styled from 'styled-components/macro'

const Wrapper = styled.div({
  backgroundColor: '#faf8f7',
  borderRadius: 15,
  display: 'flex',
  flexWrap: 'wrap',
  margin: '25px 0 40px',
})
const PrimaryCell = styled.div({
  flexGrow: 1,
  width: '50%',
  height: 80,
  border: '0px dashed #ddd',
  padding: 10,
  fontWeight: 600,
})

function PrimaryInfo() {
  return (
    <Wrapper>
      <PrimaryCell css={{ borderBottomWidth: 1, borderRightWidth: 1 }}>
        Datum
      </PrimaryCell>
      <PrimaryCell css={{ borderBottomWidth: 1 }}>Skola</PrimaryCell>
      <PrimaryCell css={{ borderRightWidth: 1 }}>Lärare</PrimaryCell>
      <PrimaryCell>Elev</PrimaryCell>
    </Wrapper>
  )
}

export default PrimaryInfo
